import * as React from "react";
type Props = {
  size?: number;
  fill?: string;
};
function PendingSvg(props: Props) {
  const { size = 17, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
    >
      <g clipPath="url(#clip0_5867_111293)">
        <path
          d="M8.5 0.5C6.91775 0.5 5.37103 0.969192 4.05544 1.84824C2.73985 2.72729 1.71447 3.97672 1.10897 5.43853C0.503466 6.90034 0.34504 8.50887 0.653721 10.0607C0.962403 11.6126 1.72433 13.038 2.84315 14.1569C3.96197 15.2757 5.38743 16.0376 6.93928 16.3463C8.49113 16.655 10.0997 16.4965 11.5615 15.891C13.0233 15.2855 14.2727 14.2602 15.1518 12.9446C16.0308 11.629 16.5 10.0823 16.5 8.5C16.4937 6.38022 15.6488 4.34906 14.1499 2.85014C12.6509 1.35122 10.6198 0.506331 8.5 0.5V0.5ZM8.5 14.5C7.31332 14.5 6.15328 14.1481 5.16658 13.4888C4.17989 12.8295 3.41085 11.8925 2.95673 10.7961C2.5026 9.69974 2.38378 8.49334 2.61529 7.32946C2.8468 6.16557 3.41825 5.09647 4.25736 4.25736C5.09648 3.41824 6.16558 2.8468 7.32946 2.61529C8.49335 2.38378 9.69975 2.5026 10.7961 2.95672C11.8925 3.41085 12.8295 4.17988 13.4888 5.16658C14.1481 6.15327 14.5 7.31331 14.5 8.5C14.4953 10.0898 13.8616 11.6132 12.7374 12.7374C11.6132 13.8616 10.0898 14.4953 8.5 14.5Z"
          fill={fill ?? "#F0BD24"}
        />
        <path
          d="M12 7.5H9.5V5C9.5 4.73478 9.39464 4.48043 9.20711 4.29289C9.01957 4.10536 8.76522 4 8.5 4C8.23478 4 7.98043 4.10536 7.79289 4.29289C7.60536 4.48043 7.5 4.73478 7.5 5V8.5C7.5 8.76522 7.60536 9.01957 7.79289 9.20711C7.98043 9.39464 8.23478 9.5 8.5 9.5H12C12.2652 9.5 12.5196 9.39464 12.7071 9.20711C12.8946 9.01957 13 8.76522 13 8.5C13 8.23478 12.8946 7.98043 12.7071 7.79289C12.5196 7.60536 12.2652 7.5 12 7.5Z"
          fill={fill ?? "#F0BD24"}
        />
      </g>
    </svg>
  );
}

export default PendingSvg;
